const videoPlayerAreas = document.querySelectorAll('.video-playerarea');

// Update the video player dimensions
function updateVideoPlayerDimensions() {
	videoPlayerAreas.forEach((videoPlayerArea) => {
		if (videoPlayerArea !== null) {
			const videoPlayerType = videoPlayerArea.getAttribute('data-video-type');
			const isVerticalVideo = videoPlayerType === 'vertical';
			const playerAreaWidth = videoPlayerArea.getBoundingClientRect().width;
			const width = isVerticalVideo ? '300px' : '100%';
			const height = isVerticalVideo ? 533 : ((playerAreaWidth / 16) * 9);
			videoPlayerArea.setAttribute('style', `width: ${width}; height: ${height}px`);
		}
	});
}

updateVideoPlayerDimensions();
window.addEventListener('resize', updateVideoPlayerDimensions);
